// @LastEditors: Jacky
// @LastEditTime: 2023-07-27 15:57:54
// @FilePath: /pool-interface/src/pages/WinePool/constants.ts
// Copyright (c) 2023 by Jacky, All Rights Reserved.

export const masterChefV2 = '0xfdfce767add9dcf032cbd0de35f0e57b04495324'
export const mjtAddress = '0x2ca48b4eea5a731c2b54e7c3944dbdb87c0cfb6f'
